import { auth } from "../config/firebase_config";

/**
 * Generates common authentication headers for API requests
 * @param additionalHeaders - Optional additional headers to include
 * @returns Promise resolving to headers object
 */
export async function getAuthHeaders(
  additionalHeaders?: Record<string, string>
): Promise<Record<string, string>> {
  const user = auth.currentUser;
  const authToken = await user?.getIdToken();

  const headers: Record<string, string> = {
    Authorization: `Bearer ${authToken}`,
    Origin: window.location.origin,
    ...additionalHeaders,
  };

  // Add X-Endpoint-API-UserInfo header for local backend development
  if (import.meta.env.VITE_LOCAL_BACKEND === "true" && user?.uid) {
    const jsonData = {
      user_id: user.uid,
    };
    const jsonString = JSON.stringify(jsonData);
    const base64Encoded = btoa(jsonString);
    headers["X-Endpoint-API-UserInfo"] = base64Encoded;
    headers["Origin"] = "https://dev.darvin.dev";
  }

  return headers;
}
